import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { startCase } from 'lodash';
import './Dashboard.scss';
import inProgress from './in-progress.svg';
import DashboardAttribute from './DashboardAttribute';
import FullAddressBuilder from '../../../common/FullAddressBuilder';


const getChangeDesc = (changeType) => {
  switch (changeType) {
    case 'Change Of Plan':
      return 'Change of Speed';
    default:
      return 'Move of Address';
  }
};
const getContactUsUri = (email, givenName, surename) => {
  const name = startCase(`${givenName} ${surename}`);
  const url = `/contact-us/My account/Follow up on previous requests/?email=${email}&name=${name}`;
  return encodeURI(url);
};
const getInProgressText = (isMove) => {
  if (isMove) {
    return 'We are working on your request. We will be in touch with a confirmation date as soon as possible. ';
  }
  return 'We are working on your request and will let you know once it\'s done. ';
};

const ChangeInProgressTile = (props) => {
  const { customerInfo } = props;
  if (!customerInfo.requestInProgress) {
    return null;
  }
  const requestType = getChangeDesc(customerInfo.requestInProgress.changeType);
  const isMove = (requestType === 'Move of Address');
  return (
    <div id="change-in-progress-tile" className="account-action-tile">
      <img
        src={inProgress}
        alt={`${requestType} request in progress`}
      />
      <br />
      <h4 className="account-action-tile-title">
        We&apos;re working on your {requestType} request
      </h4>
      <div className="account-action-tile-text">
        {getInProgressText(isMove)}
        If you have concerns you can get in touch with our support team via our&nbsp;
        <Link to={getContactUsUri(customerInfo.emailAddress, customerInfo.firstName, customerInfo.lastName)}>
          Contact Form
        </Link>.
        {customerInfo.requestInProgress.caseNumber &&
        <span> Please quote the case number below.</span>
        }
      </div>
      {!isMove &&
      <div>
        <DashboardAttribute valueId="old-speed" label="Moving from this speed">
          {customerInfo.currentPlan}
        </DashboardAttribute>
        <DashboardAttribute valueId="new-speed" label="To this speed">
          {customerInfo.requestInProgress.productOffer}
        </DashboardAttribute>
        {customerInfo.requestInProgress.caseNumber &&
        <DashboardAttribute valueId="case-number" label="Case Number">
          {customerInfo.requestInProgress.caseNumber}
        </DashboardAttribute>
        }
      </div>
      }
      {isMove &&
      <div>
        <DashboardAttribute valueId="new-address" label="Moving to" hasMultiLineValue>
          {FullAddressBuilder.buildMultiLine(customerInfo.requestInProgress)}
        </DashboardAttribute>
        <DashboardAttribute valueId="new-speed" label="With speed">
          {customerInfo.requestInProgress.productOffer}
        </DashboardAttribute>
        <DashboardAttribute valueId="connection-date" label="On this date">
          {new Date(customerInfo.requestInProgress.dateToBeConnected).toLocaleDateString()}
        </DashboardAttribute>
        {customerInfo.requestInProgress.caseNumber &&
        <DashboardAttribute valueId="case-number" label="Case Number">
          {customerInfo.requestInProgress.caseNumber}
        </DashboardAttribute>
        }
      </div>
      }
    </div>
  );
};

ChangeInProgressTile.propTypes = {
  customerInfo: PropTypes.object.isRequired
};

export default ChangeInProgressTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/ChangeInProgressTile.js
 **/